'use strict';

/**
 *
 * @param {string} pattern regex pattern
 * @param {string} field field
 * @returns {boolean} if field match the pattern
 */
const isRegexPatternValid = (pattern, field) => {
    let isRegex = false;
    let regexEp = null;
    try {
        regexEp = new RegExp(pattern);
        isRegex = !!regexEp;
    } catch (e) {
        isRegex = false;
    }

    return isRegex ? regexEp.test(field) : false;
};

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
const createErrorNotification = (message) => {
    var errorHtml = `
        <div class="alert alert-danger alert-dismissible 'fade show" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            ${message}
        </div>
    `;

    $('.error-messaging').append(errorHtml);
};

/**
 * Function to detect bandwith with an image of known size
 * @returns {Promise} Return the connection polyfill with a Promise
 */
const detectConnection = () => {
    const NetworkInformationApiPolyfill = require('network-information-api-polyfill/src/index');

    return new Promise((res) => {
        new NetworkInformationApiPolyfill().then((connection) => {
            res(connection);
        });
    });
};

/**
 * Function to detect if device uses IOS
 * @returns {boolean} Returns true if the userAgent matches IOS device
 */
const detectIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

module.exports = {
    isRegexPatternValid,
    createErrorNotification,
    detectConnection,
    detectIOS,
};
